// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__Ed37R","label":"SetPasswdForm_label__1TO1_"};